import React, {useState, useEffect} from 'react';
import {IProps, IState} from './types';
import * as S from './styles';

const PreviewGrid:React.FC<IProps> = (props, state: IState) => {

  const CARD_WIDTH = props.width?props.width:200;
  const CARD_HEIGHT = props.height?props.height:170;
  const CARD_SIZE = props.size?props.size:5;
  const [images, setImages] = useState(state.images?state.images:[]);

  useEffect(() => {
    if (props.images?.length > 0) {
      var newImages: any = [];
      var maxWidthIndex = 0;
      var maxWidthValue = 0;
      if (props.images.length>1)
      {
        props.images.map((image: any, index: number) => {
          var name = image?.size ?  image?.size?.toString().split('x') : image?.name?.toString().split('x');
          var newImage = {...image};
          
            if (name && name.length > 1 && parseInt(name[0]) && parseInt(name[1])) {
              if (name[0]/CARD_SIZE > CARD_WIDTH) newImage.width = CARD_WIDTH
              else newImage.width = name[0]/CARD_SIZE;
              if (name[1]/CARD_SIZE > CARD_WIDTH) newImage.height = CARD_HEIGHT
              else name.height = name[1]/CARD_SIZE;
            } else {
              newImage.width = CARD_WIDTH;
              newImage.height = CARD_HEIGHT;
            }
            if (name && name[0] > maxWidthValue) {
              maxWidthValue = name[0];
              maxWidthIndex = index;
            }
            newImages = [...newImages, newImage];
        });
      }
      else
      {
        var newImage:any = {...props.images[0]};     
        newImage.width = CARD_WIDTH;
        newImage.height = CARD_HEIGHT;
        newImages = [...newImages, newImage];
        
      }
      newImages = [
        newImages[maxWidthIndex],
        ...newImages.slice(0, maxWidthIndex),
        ...newImages.slice(maxWidthIndex + 1)
      ]
      setImages(newImages);
    }
  }, [props.images])


  const getUrl=(image:any)=>{
    if (props.full)
      return image.url.replace(".jpeg","_B.jpeg");
    else
      return image.url;
  }

  const getUrlError=(image:any)=>{

  }

  const handleErrorLoading = (imageName: string) => {
    setImages([...images.filter((image: any) => image.name!==imageName)]);
  }

  return (
    <S.Root
    >
      <S.Grid>
        { images?.length > 0 &&
          images.map((image: any, index: number) => {
            if (index<3) {
            return (
              <S.GridItem
                key={index}>
              {
                (props.names??false) && <S.GridItemTitle>{image.name}</S.GridItemTitle>
              }
              <S.GridImage
                key={index}
                src={getUrl(image)}
                width={image.width}
                height={image.height}   
                onError={() => handleErrorLoading(image.name)}             
              />
              </S.GridItem>
            )
          }})
        }
      </S.Grid>
    </S.Root >
  );
}

export default PreviewGrid;